var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checker-container"},[_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('selectAll')}}},[_vm._v("Select all")]),_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('clearAll')}}},[_vm._v("Clear All")])])
}
var staticRenderFns = []

export { render, staticRenderFns }